var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1716985620560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.2399 0C80.7288 0 96.5388 7.13548 107.872 18.4683C119.344 29.941 126.34 45.751 126.34 63.1C126.34 80.449 119.204 96.3989 107.872 107.732C96.3989 119.204 80.5889 126.2 63.2399 126.2C45.751 126.2 29.941 119.065 18.6082 107.732C7.13548 96.3989 0 80.5889 0 63.1C0 45.6111 7.13548 29.8011 18.4683 18.4683C29.941 7.13548 45.751 0 63.2399 0ZM106.053 20.2871C95.1397 9.37406 79.8894 2.5184 63.2399 2.5184C46.5905 2.5184 31.2002 9.37406 20.2871 20.2871C9.37406 31.2002 2.5184 46.4506 2.5184 63.2399C2.5184 80.0293 9.37406 95.1397 20.2871 106.053C31.2002 116.966 46.4506 123.822 63.2399 123.822C80.0293 123.822 95.1397 116.966 106.193 106.053C117.246 95.1397 123.961 79.8894 123.961 63.1C123.961 46.3106 116.966 31.2002 106.053 20.2871Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.543 93.6007C55.543 97.7981 58.9008 101.156 63.0982 101.156C67.2955 101.156 70.6534 97.7981 70.6534 93.6007C70.6534 89.4034 67.2955 86.0455 63.0982 86.0455C59.0407 86.0455 55.543 89.4034 55.543 93.6007ZM67.9951 93.6007C67.9951 96.259 65.8964 98.3577 63.2381 98.3577C60.5798 98.3577 58.4811 96.259 58.4811 93.6007C58.4811 90.9424 60.5798 88.8437 63.2381 88.8437C65.8964 88.8437 67.9951 90.9424 67.9951 93.6007ZM63.2381 25.1841C62.5385 25.1841 61.839 25.7437 61.839 26.5832V77.0912C61.839 77.9306 62.3986 78.4903 63.2381 78.4903C64.0776 78.4903 64.6372 77.9306 64.6372 77.0912V26.5832C64.4973 25.7437 63.9376 25.1841 63.2381 25.1841Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.3438 93.6007C58.3438 96.2591 60.4424 98.3577 63.1007 98.3577C65.759 98.3577 67.8577 96.2591 67.8577 93.6007C67.8577 90.9424 65.759 88.8438 63.1007 88.8438C60.5823 88.8438 58.3438 90.9424 58.3438 93.6007Z",
    fill: "#BC92C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorimg);
export default __webpack_public_path__ + "static/media/errorimg.b6a6c14069187c7c8d5b4f5887c03947.svg";
export { ForwardRef as ReactComponent };